import React, { useState, useEffect, useReducer } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import _ from 'lodash'
import Header from '../../header/Header'
import Footer from '../../footer/Footer'
import { Button } from 'devextreme-react/button';
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import TextArea from 'devextreme-react/text-area';
import NumberBox from 'devextreme-react/number-box';
import DateBox from 'devextreme-react/date-box';
import { TagBox } from 'devextreme-react/tag-box';
import { CheckBox } from 'devextreme-react/check-box';
import { Validator, RequiredRule } from 'devextreme-react/validator';
import kaizenReducer from '../../../reducers/kaizen';
import * as action from '../../../actions/kaizen';
import { useParams } from 'react-router-dom';
import ScrollView from 'devextreme-react/scroll-view';
import { alert } from 'devextreme/ui/dialog';
import { Toast } from 'devextreme-react/toast';


const initialKaizenState = { kaizenCategories: [], kaizenArea: [], kaizenCell: [], userData: null, allUsers: [], managerDetails: null, status: null }
const initialCIData = { idea: "", category: "", description: "", area: "", cell: "", lines: "", savings: 0, goDo: false, collaborators: [], dueDate: new Date() }

const RaiseCI = props => {
    const { category, site } = useParams()
    const navigate = useNavigate()
    const [animate, setAnimate] = useState('');
    const [state, dispatch] = useReducer(kaizenReducer, initialKaizenState)
    const { kaizenCategories, kaizenArea, kaizenCell, userData, allUsers, managerDetails, status } = state
    const [ciData, setCIData] = useState({ ...initialCIData })
    const [distinctUsers, setDistinctUsers] = useState([])
    const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });
    const [showForm, setShowForm] = useState(true);

    const handleInputChange = (e) => {
        let name = e.component.option('name')
        let value = e.value
        if (name === "area") {
            setCIData({ ...ciData, [name]: value, cell: "", lines: "" })
        }
        else if (name === "cell") {
            setCIData({ ...ciData, [name]: value, lines: "" })
        }
        else {
            setCIData({ ...ciData, [name]: value })
        }
    }

    const populateDistinctUsersList = () => {
        let modifiedUsersList = allUsers.map(ele => { return { ...ele, value: ele.employeeName + ":" + ele.employeeId } })
        let _distinctUsers = [...new Map(modifiedUsersList.map(ele => [ele["employeeId"], ele])).values(),];
        let _distUsersExclPropser = _distinctUsers.filter(ele => ele.employeeId.toUpperCase() !== userData.hId.toUpperCase())
        setDistinctUsers([..._distUsersExclPropser])
    }

    const formatDate = (date) => {
        let formattedDate = ""
        if (date) {
            let _date = new Date(date).toLocaleDateString(); // mm/dd/yyyy
            let splittedDate = _date.split('/') // [mm,dd,yyyy]
            formattedDate = splittedDate[2] + "-" + splittedDate[0] + "-" + splittedDate[1] // yyyy-mm-dd
        }
        return formattedDate
    }

    const handleSave = () => {
        if (ciData.idea.length > 4 && ciData.category && ciData.description.length > 9 && ciData.area && ciData.cell && ciData.lines) {
            action.updateKaizenStatus(dispatch, { type: "processing", message: "Processing CI.....!" })
            let date = formatDate(ciData.dueDate)
            let data = {
                tierId: site,
                siteCode: site,
                kaizenTitle: ciData.idea,
                kaizenIdea: ciData.description,
                category: ciData.category,
                location: ciData.area,
                module: ciData.cell,
                lines: ciData.lines,
                costImpact: ciData.savings,
                goDo: ciData.goDo ? "true" : "false",
                proposer: userData.employeeName,
                proposerEID: userData.hId,
                managerEID: managerDetails.employeeId,
                assignedTo: ciData.collaborators.join(';'),
                dueDate: date,
            }
            action.addKaizenRaiseCI(dispatch, data)
        } else {
            alert("Not Valid Details", "Alert")
        }
    }

    const handleBack = () => {
        navigate(`/siteApp/${category}/${site}/kaizen`)
    }

    useEffect(() => {
        if (ciData.area) {
            action.fetchKaizenCell(dispatch, site, ciData.area);
        }
    }, [ciData.area])

    useEffect(() => {
        action.fetchKaizenCategories(dispatch, site);
        action.fetchKaizenArea(dispatch, site);
        action.fetchKaizenUserData(dispatch);
        action.fetchKaizenAllUsers(dispatch);
    }, [])

    useEffect(() => {
        if (userData) {
            action.fetchManagerDetails(dispatch, userData.email)
        }
    }, [userData])

    useEffect(() => {
        if (allUsers.length > 0 && userData) {
            populateDistinctUsersList()
        }
    }, [allUsers, userData])

    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);

    const scrollConfig = {
    }

    useEffect(() => {
        if (status) {
            if (status.type === "processing") {
                setToastConfig({ ...toastConfig, isVisible: true, type: 'warning', message: status.message });
            }
            if (status.type === "success") {
                setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: status.message });
                setCIData({ ...initialCIData })
                setShowForm(false)
            }
        }
    }, [status])

    return (
        <>
            <Header showPinBtn={false} site={[]} />

            <section className="page-content">
                <div className="site-view tier-wrap admin-console-wrapper">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className="icon icon-corporate"></span>
                            <ul>
                                <li><Link to={`/`}>Home</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen`}>Kaizen</Link></li>
                                <li><b>Raise CI</b></li>
                            </ul>
                        </div>

                        <div className="raiseci-section">
                            <div className="page-heading">
                                <h2> <span className="icon kaddIdea" ></span> Raise CI </h2>
                            </div>
                            <div>
                                <Button
                                    text="Save"
                                    icon="save"
                                    type="success"
                                    stylingMode="contained"
                                    useSubmitBehavior={true}
                                    onClick={handleSave}
                                    disabled={!showForm}
                                />
                                &nbsp; &nbsp;
                                <Button
                                    text="Go Back"
                                    stylingMode="contained"
                                    onClick={handleBack}
                                />
                            </div>
                        </div>

                        {showForm
                            &&
                            <ScrollView {...scrollConfig} style={{ height: "80%" }}>

                                <div className="raiseci-cards-section">
                                    <div className="raiseci-card">
                                        <div className="raiseci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1792E5' }}>
                                                <div>
                                                    <i className="dx-icon-tips" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div>
                                                    <b>Tell Us About Your Idea</b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <TextBox
                                                    id="idea"
                                                    name="idea"
                                                    labelMode={"floating"}
                                                    label='Kaizen Idea * (min 5 letters)'
                                                    value={ciData.idea}
                                                    onValueChanged={handleInputChange}

                                                >
                                                    <Validator>
                                                        <RequiredRule message="Kaizen Idea is required and atleast 5 characters" />
                                                    </Validator>
                                                </TextBox>
                                                <SelectBox
                                                    name="category"
                                                    items={kaizenCategories}
                                                    labelMode={"floating"}
                                                    label='Category *'
                                                    value={ciData.category}
                                                    onValueChanged={handleInputChange}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Category is required" />
                                                    </Validator>
                                                </SelectBox>
                                                <TextArea
                                                    name="description"
                                                    labelMode={"floating"}
                                                    label='Description * (min 10 letters)'
                                                    value={ciData.description}
                                                    onValueChanged={handleInputChange}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Description is required and atleast 10 characters" />
                                                    </Validator>
                                                </TextArea>
                                            </div>

                                        </div>
                                        <div className="raiseci-card-info">
                                            1. <b>Give your CI </b> descriptive title and ensure you describe the problem in the description.
                                        </div>
                                    </div>
                                    <div className="raiseci-card">
                                        <div className="raiseci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1380CA' }}>
                                                <div>
                                                    <i className="dx-icon-map" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div>
                                                    <b>Where is it ?</b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <SelectBox
                                                    name="area"
                                                    items={kaizenArea}
                                                    labelMode={"floating"}
                                                    label='Area *'
                                                    value={ciData.area}
                                                    onValueChanged={handleInputChange}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Area is required" />
                                                    </Validator>
                                                </SelectBox>
                                                <SelectBox
                                                    name="cell"
                                                    items={[...kaizenCell.map(ele => ele.cell)]}
                                                    labelMode={"floating"}
                                                    label='Cell *'
                                                    value={ciData.cell}
                                                    onValueChanged={handleInputChange}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="cell is required" />
                                                    </Validator>
                                                </SelectBox>
                                                <SelectBox
                                                    name="lines"
                                                    items={ciData.cell ? kaizenCell.filter(ele => ele.cell === ciData.cell)[0].lines : []}
                                                    labelMode={"floating"}
                                                    label='Lines *'
                                                    value={ciData.lines}
                                                    onValueChanged={handleInputChange}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Line is required" />
                                                    </Validator>
                                                </SelectBox>
                                                <NumberBox
                                                    name="savings"
                                                    labelMode={"floating"}
                                                    label='Potential Yearly Savings($)'
                                                    value={ciData.savings}
                                                    onValueChanged={handleInputChange}
                                                >
                                                </NumberBox>
                                            </div>

                                        </div>
                                        <div className="raiseci-card-info">
                                            2. <b>Detail the area </b> in which improvement is to take place.
                                        </div>
                                    </div>
                                    <div className="raiseci-card">
                                        <div className="raiseci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1792BC' }}>
                                                <div>
                                                    <i className="dx-icon-group" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div>
                                                    <b>Who is involved ?</b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">

                                                <TextBox
                                                    name="proposer"
                                                    labelMode={"floating"}
                                                    label='Proposer *'
                                                    value={userData?.employeeName}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Proposer is required" />
                                                    </Validator>
                                                </TextBox>
                                                <div>
                                                    Go Do
                                                    &nbsp;
                                                    <CheckBox
                                                        name="goDo"
                                                        defaultValue={true}
                                                        value={ciData.goDo}
                                                        onValueChanged={handleInputChange}
                                                    />
                                                    &nbsp;
                                                    &nbsp;
                                                    &nbsp;
                                                    {ciData.goDo ? "No Approval Required" : "Manager Approval required"}
                                                </div>
                                                <TagBox
                                                    style={{ "width": "100%" }}
                                                    name="collaborators"
                                                    labelMode={"floating"}
                                                    label='Collaborated With'
                                                    displayExpr="employeeName"
                                                    valueExpr="value"
                                                    acceptCustomValue={true}
                                                    className="dx-field-value"
                                                    items={distinctUsers}
                                                    showSelectionControls={true}
                                                    maxDisplayedTags={4}
                                                    showMultiTagOnly={false}
                                                    searchEnabled={true}
                                                    selectAllMode="allPages"
                                                    value={ciData.collaborators}
                                                    onValueChanged={handleInputChange}
                                                >
                                                </TagBox>
                                                <DateBox
                                                    name="dueDate"
                                                    labelMode={"floating"}
                                                    label='Due Date'
                                                    defaultValue={new Date()}
                                                    min={new Date()}
                                                    value={ciData.dueDate}
                                                    onValueChanged={handleInputChange}
                                                >
                                                </DateBox>
                                            </div>

                                        </div>
                                        <div className="raiseci-card-info">
                                            3. <b>Select whose idea is it</b> and who is going to implement it. Check Go Do only if it is a CI that you will implement yourself.
                                            CI with Go DO uncheked will go for Manager Approval.
                                        </div>
                                    </div>
                                </div>
                            </ScrollView>
                        }
                        {!showForm
                            &&
                            <ScrollView {...scrollConfig} style={{ height: "80%" }}>
                                <div className="raiseci-success-card">
                                    <h3>CI Raised Successfully</h3>
                                    <i className="dx-icon-check" style={{ fontSize: "3rem", color: "#5cb85c" }}></i>
                                    <Button text="Raise Another CI" onClick={() => setShowForm(true)} />
                                    <Button text="Go Back" onClick={handleBack} />
                                </div>
                            </ScrollView>
                        }

                    </div>
                </div>
            </section>


            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
            </div>

            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={() => setToastConfig({
                    ...toastConfig,
                    isVisible: false,
                })}
                displayTime={2000}
            />
        </>
    )
};
export default RaiseCI
